<template>
  <div>
    <div class="page-title">Edit Blog Article</div>
    <Form
      v-if="form"
      v-model="form"
      :submit="update"
      btnText="Update Blog Article"
    />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.blog.page";
export default {
  components: { Form },
  metaInfo() {
    const subject = this.form?.title;
    return {
      title: subject ? `Edit “${subject}”` : `Edit Blog Article`,
    };
  },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.BlogArticle.get({
        id: this.$route.params.id,
      });
      this.form = data;
    },
    async update() {
      await this.$api.BlogArticle.update(this.form);
      this.$router.push("/blog");
    },
  },
};
</script>

<style></style>
